<template>
    
            <v-main class="pa-2" fluid>

            <RangePicker @reloadData="loadData" :range="this.getDefaultWeek()"/>

            <v-row>
              <v-col
              cols="12"
              md="6"
              lg="6"
              >
                     <v-subheader>Jumps</v-subheader>
                       <v-data-table
                           :headers="headers"
                           :items="totals"
                           :items-per-page="10"
                           >
                         
                       <template slot="body.append">
                               <tr class="pink--text">
                                   <th class="title">Totals</th>
                                   <th class="title">{{ sum(totals, 'jumps') }}</th>
                                   <th class="title">{{ sum(totals, 'wc') }}</th>
                                   <th class="title">{{ sum(totals, 'wc2') }}</th>
                                   
                               </tr>
                           </template>
                           </v-data-table>
                   </v-col>
              
                        <v-col cols="12"
              md="6"
              lg="6">
              <v-subheader>Loads</v-subheader>
                   <v-data-table
                      :headers="loadsHeaders"
                      :items="flightsTotals"
                      :items-per-page="10"
                      >
              
                       <template slot="body.append">
                          <tr class="pink--text">
                              <th class="title">Totals</th>
                              <th class="title">{{ sum(flightsTotals, 'total') }}</th>
                              
                          </tr>
                      </template>
                  
                      </v-data-table>
                        </v-col>
            </v-row>

<v-subheader>Packing Jobs</v-subheader>
<v-data-table
                      :headers="packingJobsHeaders"
                      :items="totalsbypacker"
                      :items-per-page="10"
                      >
              
                      <template slot="body.append">
                      <tr class="pink--text">
                        <th v-for="(item, index) in packingJobsHeaders" class="title">
{{ index > 0 ? sum(totalsbypacker, item.value) : " " }}
                          </th>
                      </tr>
                  </template>
                  
                      </v-data-table>

              
            </v-main>
    
</template>

<script>
    import { mapState } from 'vuex'
    import RangePicker from '../components/RangePicker.vue'

    export default {

      components : { RangePicker }, 
      
        data() {


            return {

              headers : [
                { text : "Instructor Name", align: 'left', value: "name" },
                { text : "Jumps", align: 'left', value: "jumps" },
                { text : "WC", align: 'left', value: "wc" },
                // { text : "WC1", align: 'left', value: "wc1" },
                { text : "lb/wc1", align: 'left', value: "wc2" },
              ],

              loadsHeaders : [
                { text : "Pilot Name", align: 'left', value: "name" },
                { text : "Loads", align: 'left', value: "total" }
              ]
             // dialog : false

             
            }
        },

        mounted () {

          this.$store.dispatch('fetchJumpsbyRange', {
               type : 'instructors',
                range : this.getDefaultWeek()

            })


          this.$store.dispatch('fetchLoadsbyRange', {
               
                range : this.getDefaultWeek()

            })


          this.$store.dispatch('fetchPackingJobsbyPacker', {
                range : this.getDefaultWeek()
            })


        },


        computed: {
            ...mapState(['totals']),
            ...mapState(['flightsTotals']),
            ...mapState(['totalsbypacker']),

            packingJobsHeaders () {
              return this.getHeaders(this.totalsbypacker)
            }

        },

        

        methods: {

          loadData(range) {

              this.$store.dispatch('fetchJumpsbyRange', {
               type : 'instructors',
                range : range

            })

            this.$store.dispatch('fetchLoadsbyRange', {
                range : range
            })
//fetchPackingJobsbyPacker
            this.$store.dispatch('fetchPackingJobsbyPacker', {
                range : range
            })


            

          }, 

        
        }
    }
</script>